import { ModalComponent } from "./modal.component";
import { SliderFullscreenComponent } from "../slider/slider-fullscreen.component";
import { LazyLoadImages } from "../lazy-image/lazy-image";
import { ClipboardComponent } from "../clipboard/clipboard.component";

export class SliderModalComponent extends ModalComponent {
    public static SELECTOR = ".modal--slider";

    // Click event for opening modal
    protected onClickOpen(e: Event): void {
        super.onClickOpen(e);

        const target = e.currentTarget as HTMLElement;
        const request = new XMLHttpRequest();
        request.addEventListener("load", (event) => {
            const eventResponse = event.currentTarget as XMLHttpRequest;
            if (eventResponse.status !== 200) {
                this.close();
                return;
            }
            this.modalWrapperElement.innerHTML = eventResponse.response;

            const slider = this.modalWrapperElement.querySelector(".slider--fullscreen");
            const clipboard = this.modalWrapperElement.querySelector("[data-copy-to-clipboard]");
            // Next tick
            setTimeout(() => {
                if (slider instanceof HTMLElement) {
                    const sliderInstance = new SliderFullscreenComponent(slider);
                }
                if (clipboard instanceof HTMLAnchorElement) {
                    const clipboardInstance = new ClipboardComponent(clipboard);
                }
                LazyLoadImages.init();
            });
        });
        request.open("GET", `/fotoverslagen/modal/${target.dataset.id}`);
        request.send();
    }

    // Close modal
    protected close(): void {
        super.close();

        this.modalWrapperElement.innerHTML = "";
    }
}



// WEBPACK FOOTER //
// ./components/modal/slider-modal.component.ts